var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{class:[{'hiddenTabs': !_vm.showTabs}],attrs:{"type":_vm.type},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((_vm.tabs),function(tab,i){return _c('el-tab-pane',{key:i,attrs:{"name":`t-${i}`,"label":tab.label}},[_vm._t(`tab-${i}`)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }